import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { BankAccountCombinedResult } from "../../../../../../Wrap/Models/Domains/BankAccount/BankAccountCombinedResult";
import { AccountRoleWithAccountDetails } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { BankAccountInstruction } from "../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { SingleDataStore } from "../../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../../Shared/Stores/SingleDataStoreDispacher";
import { PortfolioDashboardStoreStatic } from "./PortfolioDashboardStoreStatic";

export const PortfolioDashboardMultiSelectionDisaptcher: SingleDataStoreDispacher<
    string[]
> = new SingleDataStoreDispacher<any>();
export const PortfolioDashboardMultiSelectionStore: SingleDataStore<string[]> = new SingleDataStore<any>(
    PortfolioDashboardMultiSelectionDisaptcher
);

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const PortfolioDashboardDisaptcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const PortfolioDashboardStore: PortfolioDashboardStoreStatic = new PortfolioDashboardStoreStatic();

export const PortfolioDashboardAccountRolesDisaptcher: SingleDataStoreDispacher<AccountRoleWithAccountDetails> = new SingleDataStoreDispacher<
    any
>();
export const PortfolioDashboardAccountRolesStore: SingleDataStore<AccountRoleWithAccountDetails> = new SingleDataStore<
    any
>(PortfolioDashboardAccountRolesDisaptcher);

export const ConsolidatedAccountDisaptcher: SingleDataStoreDispacher<ClientAccount> = new SingleDataStoreDispacher<
    any
>();
export const ConsolidatedAccountStore: SingleDataStore<ClientAccount> = new SingleDataStore<any>(
    ConsolidatedAccountDisaptcher
);

export const BWABankAccountsDisaptcher: SingleDataStoreDispacher<Array<
    BankAccountCombinedResult
>> = new SingleDataStoreDispacher<any>();
export const BWABankAccountsStore: SingleDataStore<Array<BankAccountCombinedResult>> = new SingleDataStore<any>(
    BWABankAccountsDisaptcher
);
